import script from "./DeliAdt.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliAdt.vue?vue&type=script&lang=ts&setup=true"

import "./DeliAdt.vue?vue&type=style&index=0&id=95afcd20&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95afcd20"]])

export default __exports__